export const transformObjectToString = (obj: Object) => {
  const keys = Object.keys(obj);
  const values = Object.values(obj);

  return keys.map((key, index) => `${key}=${values[index]}`).join(",");
};
